/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_open_popup': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<defs><path pid="0" d="M2.625 6.708v4.667h4.667v1.167H1.458V6.708h1.167zm9.917-5.25v9.334H3.208V1.458h9.334zm-1.167 1.167h-7v7h7v-7z" id="svgicon_icon_open_popup_a"/></defs><use _fill="#7E8793" xlink:href="#svgicon_icon_open_popup_a" transform="translate(-1 -1)" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_open_popup.js